<template>
  <div class="mdl-cell mdl-cell--3-col mdl-cell--4-col-tablet mdl-cell--6-col-phone">
    <div class="mdl-textfield mdl-js-textfield mdl-selectfield">
      <input class="mdl-textfield__input" type="text"
        :id="item.id"
        :value="item.selected.name || item.default.name"
        readonly tabIndex="-1">
      <i class="material-icons">arrow_drop_down</i>
      <ul :for="item.id"
        class="mdl-menu mdl-menu--bottom-left mdl-js-menu"
        @click="menuItemSelected">
        <li class="mdl-menu__item"
          data-value="-1"
          :data-index="index"
          :data-father-id="item.default.fatherId">{{ item.default.name }}</li>
        <li class="mdl-menu__item"
          v-for="(data, i) in item.data"
          :data-i="i"
          :data-index="index"
          :data-value="data.id"
          :data-father-id="data.padreId"
          :data-photo="data.imagen"
          :key="data.id">{{ data.nombre }}</li>
        <!-- <li class="mdl-menu__item" data-value="BR" @click="menuItemSelected">Belarus</li>
        <li class="mdl-menu__item" data-value="RS" @click="menuItemSelected">Russia</li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['item', 'index', 'changeEvent'],
  data () {
    return {
    }
  },
  methods: {
    menuItemSelected (event) {
      let menu = event.currentTarget,
          menuItem = event.target

      // this.selected = menuItem.textContent
      menu.MaterialMenu.toggle()

      this.changeEvent(menuItem)
    }
  },
  mounted () {
    // this.selected = this.item.default.name
    componentHandler.upgradeElement(this.$el.querySelector('.mdl-menu'))
  }
}
</script>

<style lang="css" scoped>
  .mdl-textfield {
    width: 100%;
  }

  .mdl-textfield > i.material-icons {
    position: absolute;
    top: 24px;
    right: 0;
    z-index: -1;
  }

  .mdl-textfield > div,
  .mdl-menu__item {
    width: inherit;
  }
</style>


// WEBPACK FOOTER //
// Select.vue?0cf64a00